import { MapPin, Truck, Users, Building2 } from 'lucide-react';

const facts = [
  { icon: MapPin, k: 'Amsterdam, NL', v: 'European Headquarters' },
  { icon: Truck, k: '12 Countries', v: 'Active Distribution' },
  { icon: Users, k: '200+ Clients', v: 'B2B Partners Served' },
  { icon: Building2, k: 'B2B Only', v: 'No Retail · No B2C' },
];

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="lg:col-span-6">
            <img
              src="https://images.unsplash.com/photo-1583295125721-766a0088cd3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxBbXN0ZXJkYW0lMjBOZXRoZXJsYW5kcyUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3OTA2Mzc0MTl8MA&ixlib=rb-4.1.0&q=85"
              alt="Amsterdam, The Netherlands — Biolyn headquarters"
              className="w-full aspect-[4/3] object-cover"
              data-testid="about-image"
            />
          </div>

          {/* Text */}
          <div className="lg:col-span-6">
            <span className="text-xs tracking-[0.25em] uppercase text-[#0A7C84] mb-4 block" style={{ fontFamily: 'var(--font-mono)' }}>
              About Biolyn
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1128] mb-6 leading-[1.05]"
              style={{ fontFamily: 'var(--font-heading)', fontWeight: 900 }}
              data-testid="about-heading"
            >
              A European foundation
              <br />
              for serious research.
            </h2>
            <p className="text-base md:text-lg text-[#495057] leading-relaxed mb-5 max-w-xl" style={{ fontFamily: 'var(--font-body)' }}>
              Founded in the Netherlands, Biolyn Pharmaceutical B.V. supplies high-purity peptide APIs to organisations that cannot compromise on quality — pharmaceutical developers, research institutions, and licensed manufacturers.
            </p>
            <p className="text-sm text-[#6C757D] leading-relaxed mb-10 max-w-xl" style={{ fontFamily: 'var(--font-body)' }}>
              We operate exclusively business-to-business, pairing pharmaceutical-grade sourcing with independent third-party verification and dependable European logistics.
            </p>

            <div className="grid grid-cols-2 gap-0 border border-[#E9ECEF]" data-testid="about-facts">
              {facts.map((f, idx) => (
                <div
                  key={f.k}
                  className={`p-6 ${idx % 2 === 0 ? 'border-r border-[#E9ECEF]' : ''} ${idx < 2 ? 'border-b border-[#E9ECEF]' : ''}`}
                  data-testid={`about-fact-${idx}`}
                >
                  <f.icon className="w-5 h-5 text-[#0A7C84] mb-3" strokeWidth={1.75} />
                  <span className="block text-lg text-[#0A1128]" style={{ fontFamily: 'var(--font-heading)', fontWeight: 700 }}>{f.k}</span>
                  <span className="text-[11px] tracking-widest uppercase text-[#A0AAB2]" style={{ fontFamily: 'var(--font-mono)' }}>{f.v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
